import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {ProductBarcodeReportSelectionData} from "../../product-barcode/controls/product-barcode-report-selection-control.component";

export class ProductBarcodeReportData extends ReportData<ProductBarcodeReportData> {
    @field priceLevel: number;
    @field format: string = "5 x 13";
    @collection(ProductBarcodeReportSelectionData) barcodes: ProductBarcodeReportSelectionData[];
}
